import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import QRCode from 'qrcode.react'
import Layout from '../../layout/Layout/Layout'
import { SIDENAV_KEYS } from '../../utils/translation-constants'
import { accountsSelector, carouselCurrentItemSelector } from '../../selectors'
import NeoButton from '../../components/NeoButton/NeoButton'

export default function MyQRCode() {
  const { t } = useTranslation()
  const current = useSelector(carouselCurrentItemSelector)
  const accounts = useSelector(accountsSelector)

  const downloadQR = useCallback(() => {
    const canvas = document.getElementById('myQRCode')
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = 'MyQRCode.png'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }, [])

  return (
      <Layout>
        <div >
          <h4 className='font-weight-bold'>{t(SIDENAV_KEYS.QR_KEYS.TITLE)}</h4>
          <p className='lead'>{t(SIDENAV_KEYS.QR_KEYS.SUBTITLE)}</p>
          <div className='mt-5 d-flex align-items-center justify-content-center'>
            <QRCode
              includeMargin
              id='myQRCode'
              className='shadow-lg'
              size={250}
              value={(accounts && current.qrKey) || 'hello'}
            />
          </div>
          <div className='mt-5 col-3 mx-auto px-0'>
            <NeoButton
              type='button'
              className='btn btn-neo'
              text={t(SIDENAV_KEYS.QR_KEYS.SHARE)}
              onClick={downloadQR}
            />
          </div>
        </div>
      </Layout>
  )
}
